import type { MessagingAdminSavedView } from '../../../api/generated/model/messagingAdminSavedView'
import { LIST_PROFILES } from '../../../components/list-system/list-profiles'

export type AdminInboxRouteSearch = {
  view: MessagingAdminSavedView
  cursor?: string
  limit?: number
}

export type AdminInboxSearch = AdminInboxRouteSearch & { limit: number }

export const ADMIN_INBOX_VIEWS = [
  'assigned_to_me',
  'unassigned',
  'my_team',
  'seller',
  'supply',
  'sla_risk',
  'waiting_on_pexify',
] as const satisfies readonly MessagingAdminSavedView[]

const viewSet = new Set<string>(ADMIN_INBOX_VIEWS)

export function parseAdminInboxSearch(
  search: Record<string, unknown>,
): AdminInboxRouteSearch {
  const validView =
    search.view === undefined ||
    (typeof search.view === 'string' && viewSet.has(search.view))
  const view =
    validView && typeof search.view === 'string'
      ? (search.view as MessagingAdminSavedView)
      : 'my_team'
  const suppliedLimit = search.limit !== undefined
  const parsedLimit =
    typeof search.limit === 'number'
      ? search.limit
      : typeof search.limit === 'string'
        ? Number(search.limit)
        : Number.NaN
  const validLimit = LIST_PROFILES.standard.pageSizes.includes(
    parsedLimit as 25 | 50 | 100,
  )
  const limit = validLimit ? parsedLimit : undefined
  const cursor =
    validView &&
    (validLimit || !suppliedLimit) &&
    typeof search.cursor === 'string' &&
    search.cursor.length > 0
      ? search.cursor
      : undefined

  return {
    view,
    ...(cursor ? { cursor } : {}),
    ...(suppliedLimit && limit ? { limit } : {}),
  }
}
